import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { BodyMedium } from "Cobalt/BodyText";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("Callout");
export type CalloutProps = {
  type: "success" | "info" | "warning" | "error";
  icon?: string;
  title?: string;
  body?: string | React.ReactNode;
  className?: string;
  showIcon?: boolean;
  children?: React.ReactNode;
};
// maps the name of the icon to the callout type it belongs to
const ICON_MAP = {
  success: "check-circle",
  info: "question-circle",
  warning: "exclamation-triangle",
  error: "info-circle",
};
export const Callout = ({ type, title, body, showIcon = false, icon, className, children, ...props }: CalloutProps) => {
  const classes = classnames(bem(), bem(null, type), className);
  return (
    <Div p={4} {...props} className={classes}>
      {showIcon && <Icon className={bem("Icon")} icon={icon || ICON_MAP[type]} flavor="solid" size="lg" pr={4} />}
      <Div>
        {title && (
          <BodyMedium weight="bold" className={bem("Title")} mb={3}>
            {title}
          </BodyMedium>
        )}
        {body && <BodyMedium>{body}</BodyMedium>}
        {children}
      </Div>
    </Div>
  );
};
Callout.propTypes = {
  type: PropTypes.oneOf(["success", "info", "warning", "error"]),
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  showIcon: PropTypes.bool,
};
